import EditableText from './EditableText.connect';
import * as EditableTextSelectors from './EditableText.selectors';

EditableText.selectors = EditableTextSelectors;
export default EditableText;
